module.exports = __webpack_public_path__ + "static/img/2_1.a0730ab0.jpg";